import { Action } from '@ngrx/store';
import { EntriesState } from '../../../features/store/base-feature-state';
import { MiniShoppingList, WritableShoppingListSearchResult } from '../../../model';
import { UserActions } from '../actions';
import { ShoppingListActionTypes } from '../actions/shopping-list.action';

export const initialState: EntriesState<MiniShoppingList> = {};

export function reducer(state = initialState, action: Action): EntriesState<MiniShoppingList> {
  switch (action.type) {
    case ShoppingListActionTypes.SearchWritableShoppingListsSuccess: {
      const _action = <UserActions.SearchWritableShoppingListsSuccess>action;
      const payload: WritableShoppingListSearchResult = _action.payload.searchResult;
      const results = payload.results;

      return results.reduce(
        (entities: { [id: number]: MiniShoppingList }, miniShoppingList: MiniShoppingList) => {
          return {
            ...entities,
            [miniShoppingList.code]: miniShoppingList,
          };
        },
        {
          ...state,
        }
      );
    }
    default:
      return state;
  }
}
